export default __webpack_public_path__ + "../staticImages/fallback_bps_de_de.svg";